import { LobbyStaffStatusState } from './../lobby-staff-status.state';
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { State } from "src/app/state/app.state";

const getLobbyStaffStatusFeatureState = createFeatureSelector<LobbyStaffStatusState>('lobbyStaffStatus');

export const getlobbyStaffGridData = createSelector(
    getLobbyStaffStatusFeatureState,
    state => state.lobbyStaffGridData
);

export const getlobbyGridData = createSelector(
    getLobbyStaffStatusFeatureState,
    state => state.lobbyGridData
);
export const getImpersonateUserDetails = createSelector(
    getLobbyStaffStatusFeatureState,
    state => state.impersonateUserDetails
);
export const getShouldPromptImpersonationPoup = createSelector(
    getLobbyStaffStatusFeatureState,
    state => state.PromptImpersonatePopup
);
export const getImpersonateAssistDetails = createSelector(
    getLobbyStaffStatusFeatureState,
    state => state.impersonateAssistDetails
);